// function stole from https://stackoverflow.com/a/11381730

export const isMobile = () =>
  window.innerWidth <= 800 || window.innerHeight <= 600;
